import React from 'react';
import BreadCrumb from 'common/breadcrumb';
import Widgets from './widgets';
import LocationBased from './location-based';
import Interaction from './Interaction';
import UserDevice from './user-device';
import Satisfaction from './satisfaction';
import DailyVisit from './daily-visit';
import Reports from './reports';
import MonthlyCampaign from './monthly-campaign';
import Subscription from './subscription';
import TrafficSource from './traffic-source';
import ProductsStatistics from './products-statistics';

const Analytics = () => {

  return (
    <React.Fragment>
      <BreadCrumb title='Analytics' pageTitle='Dashboards' />
      <div className="grid grid-cols-12 gap-x-5">
        <Widgets />
        <LocationBased />
        <Interaction />
        <UserDevice />
        <Satisfaction />
        <DailyVisit />
        <ProductsStatistics />
        <Reports />
        <MonthlyCampaign />
        <Subscription />
        <TrafficSource />
      </div>
    </React.Fragment>
  );
};

export default Analytics;
